export default defineNuxtRouteMiddleware((to) => {
  const flags = useFeatureFlags()

  const values = Object.values(flags.value || {})

  for (const value of values) {
    if (!value.enable) {
      const matched = to.matched.findIndex(route => value.routes.includes(route.path))
      if (matched > -1)
        return navigateTo('/', { replace: true })
    }
  }
})
